/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Rating, Tab, Typography } from '@mui/material';
import { DatePickers, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { AccessRoleDTO, AccessRoleFilterDTO, CompanyDTO, CompanyFilterDTO, WorkItemDTO, WorkItemFilterDTO, PeopleDTO, PeopleFilterDTO, UserDTO, ValueListDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { TabContext, TabList, TabPanel } from '@mui/lab';

interface IWorkItemMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const WorkItemMaintenance: React.FC<IWorkItemMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [categoryList, setCategoryList] = useState<ValueListDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [priorityList, setPriorityList] = useState<ValueListDTO[]>([]);
    const [responsibleList, setResposibleList] = useState<PeopleDTO[]>([]);
    const [requesterList, setRequesterList] = useState<UserDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);
    const [workItemDTO, setWorkItemDTO] = useState<WorkItemDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    const [value, setValue] = React.useState('1');

    useEffect(() => {
        setWorkItemDTO({
            ...workItemDTO,
            id: '',
            name: '',
            code: 'TSK',
            externalCode: '',
            typeId: '',
            categoryId: '',
            statusId: ListId.worksphere.workItem.startStatus,
            description: '',
            escope: '',
            outEscope: '',
            premises: '',
            restrictions: '',
            priorityId: '',
            kanbanIndex: 0,
            startDateTime: undefined,
            expectedClosingDateTime: undefined,
            estimatedEffort: 0,
            responsibleId: '',
            requesterId: '',
            companyId: userInfo.user.companyId,
        } as WorkItemDTO);

        if (isOpenMaintenance) {
            handleListGetAll(ListId.worksphere.workItem.typeId, setTypeList);
            handleListGetAll(ListId.worksphere.workItem.statusId, setStatusList);

            handleCompanyGetAll();
            handleUserGetAllAsync();

            handleGetWorkItemByIdAsync();

            handleGetPermission(ListId.worksphere.workItemId, setAccessRolePermissionDTO);
        }
    }, [data, isOpenMaintenance]);

    // useEffect(() => {
    //     handlePeopleGetAllAsync(workItemDTO?.companyId || '', setRequesterList);
    //     handlePeopleGetAllAsync(workItemDTO?.companyId || '', setResposibleList);
    // }, [workItemDTO?.companyId]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList,);
    }, []);
    
    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1('parmsphere.valueList', valueListFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handlePeopleGetAllAsync = useCallback(async (companyId: string, setUserList: any) => {
        if (companyId === undefined || companyId === '') {
            return;
        }
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            companyId: companyId
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setUserList, showMessage);
    }, []);

    const handleCompanyGetAll = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            companyId: userInfo.user.CompanyId,
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleGetWorkItemByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('worksphere.workItem', data.id, setLoading, setWorkItemDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = workItemDTO as WorkItemDTO;

        if (workItemDTO?.id === '' || workItemDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            // dto.code = companyList.find(x => x.id === dto.companyId)?.code;

            GenericService.AddAsync1('worksphere.workItem', dto, setWorkItemDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            if (!accessRolePermissionDTO?.allowUpdate) {
                showMessage('There is no permission for this access.', 'info');
                return;
            }
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('worksphere.workItem', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [workItemDTO]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);

        if (type != 'success')
            setIsOpenMaintenance(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: 'Cancel', icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='DEMAND DETAILS'
                icon='grid_view_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <TabContext value={value} >
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                                        <Tab label="Details" value="1" />
                                        {/* <Tab label="Scope" value="2" />
                                        <Tab label="Out Scope" value="3" />
                                        <Tab label="Premises" value="4" />
                                        <Tab label="Restrictions" value="5" /> */}
                                    </TabList>
                                </Box>
                                <TabPanel value="1" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        {/* <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='companyId'
                                                label='Company'
                                                placeholder='Company'
                                                value={workItemDTO?.companyId}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                valueList={companyList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid> */}
                                        <Grid item xs={12} md={6}>
                                            <TextFieldInput
                                                id='name'
                                                label='Name'
                                                value={workItemDTO?.name}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                required={true}
                                                maxLength={200}
                                                autoFocus={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='code'
                                                label='Code'
                                                value={workItemDTO?.code}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                required={true}
                                                maxLength={20}
                                                readonly={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='assigninId'
                                                label='Assignin'
                                                placeholder='Assignin'
                                                value={workItemDTO?.assigninId}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                valueList={requesterList}
                                                required={true}
                                                hasNoneSelect={false}
                                                labelKey='fullName'
                                                valueKey='id'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='statusId'
                                                label='Status'
                                                placeholder='Status'
                                                value={workItemDTO?.statusId}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                valueList={statusList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='tag'
                                                label='Tag'
                                                value={workItemDTO?.tag}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                required={true}
                                                maxLength={200}
                                                autoFocus={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DatePickers
                                                id='startDateTime'
                                                label='Start Date'
                                                value={workItemDTO?.startDateTime ?? null}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DatePickers
                                                id='endDateTime'
                                                label='End Date'
                                                value={workItemDTO?.endDateTime ?? null}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DatePickers
                                                id='targetDate'
                                                label='Target Date'
                                                value={workItemDTO?.targetDate ?? null}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='typeId'
                                                label='Type'
                                                placeholder='Type'
                                                value={workItemDTO?.typeId}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                valueList={typeList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='description'
                                                label='Description'
                                                value={workItemDTO?.description}
                                                setValue={setWorkItemDTO}
                                                obj={workItemDTO}
                                                required={true}
                                                maxLength={400}
                                                autoFocus={false}
                                                multiline={true}
                                                rows={4}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Grid>
                        {workItemDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={workItemDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === workItemDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(workItemDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === workItemDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(workItemDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};